import React from 'react';
import { Card, CardContent, CardActions, Button, Typography, Box, Tooltip, Divider, Chip, Slider } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { Save20SVGIcon, LeftCurveArrowSVGIcon } from './../common/svgHelper';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PAGE_URLS } from '../common/Constants';
import EnterpriseCard from './molecules/EnterpriseCard';
const PRIMARY_COLOR = '#7f59e5';
let featuresPlanStarter = [
  { index: 1, desc: '<span><b>200</b> video minutes</span>', isHtml: true },
  { index: 2, desc: '<span><b>2</b> million royalty-free videos from Storyblocks</span>', isHtml: true },
  { index: 3, desc: '<span><b>Unlimited</b> standard voices in <b>7</b> <br/>languages</span>', isHtml: true },
  { index: 4, desc: '<span><b>1</b>  brand kit</span>', isHtml: true },
];

let featuresPlanProfessional = [
  {
    index: 1,
    desc: '<span><b>600</b> video minutes</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span><b>18</b> million royalty-free videos <br />from Getty and Storyblocks</span>',
    isHtml: true,
  },
  {
    index: 3,
    desc: `<span><b>120</b> minutes of ElevenLab's AI voices in <b>29</b> languages</span>`,
    isHtml: true,
  },
  {
    index: 4,
    desc: '<span><b>5</b> brand kits</span>',
    isHtml: true,
  },
];

let featuresPlanTeam = [
  {
    index: 1,
    desc: '<span><b>1800</b> video minutes</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span><b>18</b> million royalty-free videos <br />from Getty and Storyblocks</span>',
    isHtml: true,
  },

  {
    index: 3,
    desc: `<span><b>240</b> minutes of ElevenLab's AI voices in <b>29</b> languages</span>`,
    isHtml: true,
  },
  {
    index: 4,
    desc: '<span><b>10</b> brand kits</span>',
    isHtml: true,
  },
];

let featuresPlanEnterprise = [
  {
    index: 2,
    desc: '<span><b>18</b> million royalty-free videos <br />from Getty and Storyblocks</span>',
    isHtml: true,
  },

  {
    index: 3,
    desc: `<span><b>Custom</b> ElevenLab's AI voices in 29 languages</span>`,
    isHtml: true,
  },
  {
    index: 4,
    desc: '<span><b>Unlimited</b> brand kits</span>',
    isHtml: true,
  },
];

let featuresPlanApi = [
  {
    index: 2,
    desc: '<span><b>18</b> million royalty-free videos <br />from Getty and Storyblocks</span>',
    isHtml: true,
  },
  {
    index: 3,
    desc: `<span><b>Custom</b> ElevenLab's AI voices in 29 languages</span>`,
    isHtml: true,
  },
  {
    index: 4,
    desc: '<span><b>Unlimited</b> brand kits</span>',
    isHtml: true,
  },
];

const KEY_FEATURES_PROFESSIONAL = [
  {
    index: 1,
    desc: '<span>Advanced AI Tools</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span>Video summarizations of long videos</span>',
    isHtml: true,
  },
  {
    index: 3,
    desc: '<span>Auto-sync of uploaded voice overs</span>',
    isHtml: true,
  },
];

let COURSES_LIST = [
  {
    index: 1,
    desc: '<span>Youtube Mastery</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span>Video Marketing Made Easy</span>',
    isHtml: true,
  },
];

const KEY_FEATURES_STARTER = [
  {
    index: 1,
    desc: '<span>No watermark</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span>Basic AI Tools</span>',
    isHtml: true,
  },
  {
    index: 3,
    desc: '<span>Auto-sync of uploaded voice overs</span>',
    isHtml: true,
  },
];

const KEY_FEATURES_TEAMS = [
  {
    index: 1,
    desc: '<span>Professional onboarding and team training</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span>API automation to scale video creation</span>',
    isHtml: true,
  },
];

const KEY_FEATURES_ENTERPRISE = [
  {
    index: 1,
    desc: '<span>Initial 3 month on-boarding and support for integration</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span>3 hours of Pictory services to assist with creating custom templates</span>',
    isHtml: true,
  },
  {
    index: 3,
    desc: '<span>On-going priority support</span>',
    isHtml: true,
  },
  {
    index: 4,
    desc: '<span>Priority access to new features</span>',
    isHtml: true,
  },
];

const KEY_FEATURES_API = [
  {
    index: 1,
    desc: '<span>Dedicated success manager</span>',
    isHtml: true,
  },
  {
    index: 2,
    desc: '<span>Great for automation services like <b>Make.com, Zapier, N8N</b> and others</span>',
    isHtml: true,
  },
  {
    index: 3,
    desc: '<span>Video consulting</span>',
    isHtml: true,
  },
];

class CustomCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      billingTypeYearly: true,
      apiAddonValue: 0,
    };
  }
  changeCheckedValue = event => {
    //event.stopPropagation();
    //event.value = !event.value;
    this.setState(
      {
        billingTypeYearly: !this.state.billingTypeYearly,
      },
      () => {
        this.setState({
          planType: this.state.billingTypeYearly ? 'years' : 'months',
        });
      }
    );
  };
  renderFeaturesListForPlan = (plan_code, currentPlanCode, iconColor) => {
    let featuresOfPlan = null;

    if (plan_code.includes('Starter') || plan_code.includes('Standard')) {
      featuresOfPlan = featuresPlanStarter;
    } else if (plan_code.toLowerCase().includes('team')) {
      featuresOfPlan = featuresPlanTeam;
    } else if (plan_code.includes('Professional')) {
      featuresOfPlan = featuresPlanProfessional;
    } else if (plan_code.includes('Enterprise')) {
      featuresOfPlan = featuresPlanEnterprise;
    } else if (plan_code.includes('API_PLAN')) {
      featuresOfPlan = featuresPlanApi;
    } else {
      return;
    }

    if (!featuresOfPlan) return;
    return (
      <Box className="checkbox-menu">
        {featuresOfPlan.map(feature => {
          return (
            <p
              style={{
                display: 'flex',
                gap: '5px',
                fontSize: '14px',
              }}
            >
              <Box
                sx={{
                  minWidth: '24px',
                  minHeight: '24px',
                  maxHeight: '24px',
                  maxWidth: '24px',
                }}
              >
                {/* <CheckmarkSVGIcon strokeColor="#5939A2" /> */}
                <CheckCircleIcon sx={{ color: PRIMARY_COLOR }} />
              </Box>
              {feature.isHtml ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: feature.desc?.replace('{{api_minutes}}', 600 + this.state.apiAddonValue),
                  }}
                  style={{
                    minWidth: '20px',
                  }}
                ></span>
              ) : (
                feature.desc?.replace('{{api_minutes}}', 600 + this.state.apiAddonValue)
              )}
              {feature.hasInfoToolTip && (
                <>
                  {' '}
                  <Tooltip title={this.buyTranscriptionAnchor()} placement="top-start" arrow>
                    <span>
                      <InfoOutlined width="16px" height="16px" strokeColor="#607D8B"></InfoOutlined>
                    </span>
                  </Tooltip>
                </>
              )}
            </p>
          );
        })}
      </Box>
    );
  };

  renderAdvancedAIFeatures = (plan_code, currentPlanCode, iconColor) => {
    let featuresOfPlan = null;
    if (plan_code.includes('Professional')) {
      featuresOfPlan = KEY_FEATURES_PROFESSIONAL;
    } else if (plan_code.includes('Starter')) {
      featuresOfPlan = KEY_FEATURES_STARTER;
    } else if (plan_code.includes('Teams')) {
      featuresOfPlan = KEY_FEATURES_TEAMS;
    } else if (plan_code.includes('Enterprise')) {
      featuresOfPlan = KEY_FEATURES_ENTERPRISE;
    } else if (plan_code.includes('API_PLAN')) {
      featuresOfPlan = KEY_FEATURES_API;
    } else {
      return;
    }

    if (!featuresOfPlan) return;
    return (
      <Box className="checkbox-menu" sx={{ marginTop: '0px' }}>
        {featuresOfPlan.map(feature => {
          return (
            <p
              style={{
                display: 'flex',
                gap: '5px',
                fontSize: '14px',
              }}
            >
              <Box
                sx={{
                  minWidth: '24px',
                  minHeight: '24px',
                  maxHeight: '24px',
                  maxWidth: '24px',
                }}
              >
                {/* <CheckmarkSVGIcon strokeColor="#5939A2" /> */}
                <CheckCircleIcon sx={{ color: PRIMARY_COLOR }} />
              </Box>
              {feature.isHtml ? (
                <span
                  dangerouslySetInnerHTML={{ __html: feature.desc }}
                  style={{
                    minWidth: '20px',
                  }}
                ></span>
              ) : (
                feature.desc
              )}
              {feature.hasInfoToolTip && (
                <>
                  {' '}
                  <Tooltip title={this.buyTranscriptionAnchor()} placement="top-start" arrow>
                    <span>
                      <InfoOutlined width="16px" height="16px" strokeColor="#607D8B"></InfoOutlined>
                    </span>
                  </Tooltip>
                </>
              )}
            </p>
          );
        })}
      </Box>
    );
  };

  renderFreeCoursesList = (plan_code, currentPlanCode, iconColor) => {
    let featuresOfPlan = null;
    if (plan_code.includes('Starter')) {
      featuresOfPlan = [COURSES_LIST[0]];
    } else {
      featuresOfPlan = COURSES_LIST;
    }

    if (!featuresOfPlan) return;
    return (
      <Box className="checkbox-menu" sx={{ marginTop: '0px' }}>
        {featuresOfPlan.map(feature => {
          return (
            <p
              style={{
                display: 'flex',
                gap: '5px',
                fontSize: '14px',
              }}
            >
              <Box
                sx={{
                  minWidth: '24px',
                  minHeight: '24px',
                  maxHeight: '24px',
                  maxWidth: '24px',
                }}
              >
                {/* <CheckmarkSVGIcon strokeColor="#5939A2" /> */}
                <CheckCircleIcon sx={{ color: PRIMARY_COLOR }} />
              </Box>
              {feature.isHtml ? (
                <span
                  dangerouslySetInnerHTML={{ __html: feature.desc }}
                  sx={{
                    minWidth: '20px',
                  }}
                ></span>
              ) : (
                feature.desc
              )}
              {feature.hasInfoToolTip && (
                <>
                  {' '}
                  <Tooltip title={this.buyTranscriptionAnchor()} placement="top-start" arrow>
                    <span>
                      <InfoOutlined width="16px" height="16px" strokeColor="#607D8B"></InfoOutlined>
                    </span>
                  </Tooltip>
                </>
              )}
            </p>
          );
        })}
      </Box>
    );
  };
  handleSliderChange = (event, newValue) => {
    this.setState({ apiAddonValue: newValue });
  };

  render() {
    return (
      <>
        <div style={{ marginTop: '50px' }}>
          <Box className="switch-container">
            <a href="https://www.pictory.ai" target="_blank" rel="noreferrer">
              <img src="/images/pictory.png" style={{ zoom: '0.15' }} alt="Pictory Logo"></img>
            </a>
            <Box sx={{ display: 'flex' }}>
              <Box className="mask-box">
                <Box
                  className="mask"
                  style={{
                    transform: `translateX(${!this.state.billingTypeYearly ? 0 : '75px'})`,
                  }}
                />
                <Button
                  disableRipple
                  variant="text"
                  disableElevation
                  sx={{ color: !this.state.billingTypeYearly ? '#ffffff' : '#5F6178' }}
                  style={{ backgroundColor: 'transparent', boxShadow: 'none' }}
                  onClick={() => this.changeCheckedValue()}
                >
                  Monthly
                </Button>
                <Button
                  disableRipple
                  variant="text"
                  disableElevation
                  sx={{ color: this.state.billingTypeYearly ? '#ffffff' : '#5F6178' }}
                  style={{ backgroundColor: 'transparent', boxShadow: 'none' }}
                  onClick={() => this.changeCheckedValue()}
                >
                  Yearly
                </Button>
              </Box>
            </Box>
            <Box className="switch-container" style={{ right: '18px', top: '40px' }}>
              {/* <span className="red small-font" style={{ fontSize: '12px', margin: '0px' }}>
              SAVE MORE THAN 24%
            </span>
            <span style={{ margin: '1px' }}>
              <UpArrowSVG />
            </span> */}
              <Box>
                <LeftCurveArrowSVGIcon />
                <Box
                  sx={{
                    margin: '-8px 0 0 0 ',
                  }}
                >
                  <Save20SVGIcon />
                </Box>
              </Box>
            </Box>
          </Box>
        </div>
        <div
          className="allCards"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {this.props?.location?.pathname === PAGE_URLS.API_PLAN_CHECKOUT ? (
            <>
              <Card
                className="childCard"
                style={{ width: '375px', margin: '0 10px', display: 'flex', flexDirection: 'column' }}
              >
                <CardContent className="innerTopContainer">
                  <Typography
                    sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bolder' }}
                    variant="h5"
                    component="h1"
                  >
                    API Self-Serve
                  </Typography>
                  <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 600 }} variant="span">
                    For businesses who want to automate their video creation using Pictory's API
                  </Typography>
                </CardContent>
                <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <Typography variant="h6" component="h2" style={{ textAlign: 'left' }}>
                      <>
                        <span style={{ fontSize: '50px' }}>
                          {this.state.billingTypeYearly
                            ? `$${79 + (this.state.apiAddonValue / 120) * 49}`
                            : `$${99 + (this.state.apiAddonValue / 120) * 49}`}
                        </span>{' '}
                        /month billed {this.state.billingTypeYearly ? 'yearly' : 'monthly'}
                      </>
                    </Typography>
                    <Typography
                      variant="h6"
                      component="h2"
                      style={{ textAlign: 'left', fontSize: '24px', marginTop: '10px' }}
                    >
                      Video & Elevenlabs mins
                    </Typography>
                    <Slider
                      onChange={this.handleSliderChange}
                      aria-label="api-addon-quantity"
                      defaultValue={0}
                      getAriaValueText={() => 'sahil'}
                      valueLabelDisplay="auto"
                      shiftStep={120}
                      step={120}
                      marks
                      min={0}
                      max={2400}
                      value={this.state.apiAddonValue}
                      sx={{ color: 'rgb(127, 89, 229)' }}
                    />
                    <p
                      style={{
                        display: 'flex',
                        gap: '5px',
                        fontSize: '14px',
                      }}
                    >
                      <Box
                        sx={{
                          minWidth: '24px',
                          minHeight: '24px',
                          maxHeight: '24px',
                          maxWidth: '24px',
                        }}
                      >
                        <CheckCircleIcon sx={{ color: PRIMARY_COLOR }} />
                      </Box>
                      <span
                        style={{
                          minWidth: '20px',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '18px',
                          }}
                        >
                          <b>{600 + this.state.apiAddonValue}</b> video minutes
                        </span>
                      </span>
                    </p>
                    <Divider sx={{ background: PRIMARY_COLOR, margin: '15px 0px' }} />
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{
                        textAlign: 'left',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        paddingTop: '20px',
                        marginLeft: '12px',
                      }}
                    >
                      INCLUDES
                    </Typography>
                    {this.renderFeaturesListForPlan('API_PLAN', 'ProfessionalMonthlyLimitedUsePerUser', 'red')}
                    <div style={{ marginTop: 'auto' }}>
                      <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                          onClick={() =>
                            this.props.getHostedPage(
                              this.state.billingTypeYearly
                                ? 'Pictory-API-Self-Service-USD-Yearly'
                                : 'Pictory-API-Self-Service-USD-Monthly',
                              null,
                              this.state.apiAddonValue > 0
                                ? [
                                    {
                                      addonCode: 'APIAdditionalCredits-USD-Monthly',
                                      quantity: this.state.apiAddonValue / 120,
                                    },
                                  ]
                                : undefined
                            )
                          }
                          variant="contained"
                          color="primary"
                          style={{
                            width: '100%',
                            background: PRIMARY_COLOR,
                            marginBottom: '12px',
                            height: '50px',
                            fontSize: '18px',
                          }}
                        >
                          Buy Now
                        </Button>
                      </CardActions>
                    </div>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ textAlign: 'left', fontSize: '18px', fontWeight: 'bold', marginLeft: '12px' }}
                    >
                      KEY FEATURES
                    </Typography>
                    {this.renderAdvancedAIFeatures('API_PLAN', '', 'red')}
                  </Box>
                </CardContent>
              </Card>
              <EnterpriseCard
                renderFeaturesListForPlan={this.renderFeaturesListForPlan}
                renderAdvancedAIFeatures={this.renderAdvancedAIFeatures}
              />
            </>
          ) : (
            <>
              <Card
                className="childCard"
                style={{ width: '350px', margin: '0 10px', display: 'flex', flexDirection: 'column' }}
              >
                <CardContent className="innerTopContainer">
                  <Typography
                    sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bolder' }}
                    variant="h5"
                    component="h1"
                  >
                    Starter
                  </Typography>
                  <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 600 }} variant="span">
                    For creators starting their video <br /> journey
                  </Typography>
                </CardContent>
                <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    {/* <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                {this.state.billingTypeYearly ? '$19 / month' : '$25 / month'}
              </Typography> */}
                    <Typography variant="h6" component="h2" style={{ textAlign: 'left' }}>
                      <>
                        <span style={{ fontSize: '50px' }}>{this.state.billingTypeYearly ? '$19' : '$25'}</span> per
                        month
                      </>
                    </Typography>
                    <Divider sx={{ background: PRIMARY_COLOR, margin: '15px 0px' }} />

                    <h3 style={{ marginBottom: '0px', marginLeft: '12px' }}>1 User</h3>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{
                        textAlign: 'left',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        paddingTop: '20px',
                        marginLeft: '12px',
                      }}
                    >
                      INCLUDES
                    </Typography>
                    {this.renderFeaturesListForPlan('Starter', 'ProfessionalMonthlyLimitedUsePerUser', 'red')}
                    <div style={{ marginTop: 'auto' }}>
                      <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                          onClick={() =>
                            this.props.getHostedPage(
                              this.state.billingTypeYearly
                                ? 'StarterAnnualLimitedUsePerUser'
                                : 'StarterMonthlyLimitedUsePerUser'
                            )
                          }
                          variant="contained"
                          color="primary"
                          style={{
                            width: '100%',
                            background: PRIMARY_COLOR,
                            marginBottom: '12px',
                            height: '50px',
                            fontSize: '18px',
                          }}
                        >
                          Buy Now
                        </Button>
                      </CardActions>
                    </div>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ textAlign: 'left', fontSize: '18px', fontWeight: 'bold', marginLeft: '12px' }}
                    >
                      KEY FEATURES
                    </Typography>
                    {this.renderAdvancedAIFeatures('Starter', '', 'red')}
                  </Box>
                </CardContent>
              </Card>
              <Card
                className="childCard"
                style={{
                  width: '350px',
                  margin: '0 10px',
                  display: 'flex',
                  flexDirection: 'column',
                  border: `3px solid ${PRIMARY_COLOR}`,
                }}
              >
                <CardContent className="innerTopContainer">
                  <Typography
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontWeight: 'bolder',
                      gap: '50px',
                      alignItems: 'center',
                    }}
                    variant="h5"
                    component="h1"
                  >
                    Professional
                    <Box style={{}} id="idPlanCardTagBestValue">
                      <Chip
                        label="Most Popular"
                        color="primary"
                        size="small"
                        sx={{
                          backgroundColor: PRIMARY_COLOR,
                        }}
                      />
                    </Box>
                  </Typography>
                  <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 600 }} variant="span">
                    For video creators who need <br />
                    professional-quality results
                  </Typography>
                </CardContent>
                <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <Typography variant="h6" component="h2" style={{ textAlign: 'left' }}>
                      <>
                        <span style={{ fontSize: '50px' }}>{this.state.billingTypeYearly ? '$29' : '$49'}</span> per
                        month
                      </>
                    </Typography>
                    <Divider sx={{ background: PRIMARY_COLOR, margin: '15px 0px' }} />

                    <h3 style={{ marginBottom: '0px', marginLeft: '12px' }}>1 User</h3>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{
                        textAlign: 'left',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        paddingTop: '20px',
                        marginLeft: '12px',
                      }}
                    >
                      INCLUDES
                    </Typography>
                    {this.renderFeaturesListForPlan('Professional', 'StarterMonthlyLimitedUsePerUser', 'red')}
                    {/* {this.renderAdvancedAIFeatures('Professional', 'StarterMonthlyLimitedUsePerUser', 'red')} */}
                    <div style={{ marginTop: 'auto' }}>
                      <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                          onClick={() =>
                            this.props.getHostedPage(
                              this.state.billingTypeYearly
                                ? 'ProfessionalAnnualLimitedUsePerUser'
                                : 'ProfessionalMonthlyLimitedUsePerUser'
                            )
                          }
                          variant="contained"
                          color="primary"
                          style={{
                            width: '100%',
                            background: PRIMARY_COLOR,
                            marginBottom: '12px',
                            height: '50px',
                            fontSize: '18px',
                          }}
                        >
                          Buy Now
                        </Button>
                      </CardActions>
                    </div>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ textAlign: 'left', fontSize: '18px', fontWeight: 'bold', marginLeft: '12px' }}
                    >
                      EVERYTHING IN STARTER PLUS
                    </Typography>
                    {this.renderAdvancedAIFeatures('Professional', '', 'red')}
                  </Box>
                </CardContent>
              </Card>
              <Card
                className="childCard"
                style={{ width: '350px', margin: '0 10px', display: 'flex', flexDirection: 'column' }}
              >
                <CardContent className="innerTopContainer">
                  <Typography
                    sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bolder' }}
                    variant="h5"
                    component="h1"
                  >
                    Teams
                  </Typography>
                  <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 600 }} variant="span">
                    For teams who work together to <br />
                    create videos
                  </Typography>
                </CardContent>
                <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    {/* <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                {this.state.billingTypeYearly ? '$99 / month' : '$119 / month'}
              </Typography> */}
                    <Typography variant="h6" component="h2" style={{ textAlign: 'left' }}>
                      <>
                        <span style={{ fontSize: '50px' }}>{this.state.billingTypeYearly ? '$99' : '$119'}</span> per
                        month
                      </>
                    </Typography>
                    <Divider sx={{ background: PRIMARY_COLOR, margin: '15px 0px' }} />

                    <h3 style={{ marginBottom: '0px', marginLeft: '12px' }}>3+ Users</h3>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{
                        textAlign: 'left',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        paddingTop: '20px',
                        marginLeft: '12px',
                      }}
                    >
                      INCLUDES
                    </Typography>
                    {this.renderFeaturesListForPlan('Teams', 'ProfessionalMonthlyLimitedUsePerUser', 'red')}
                    <div style={{ marginTop: 'auto' }}>
                      <CardActions style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <Button
                          onClick={() =>
                            this.props.getHostedPage(this.state.billingTypeYearly ? 'TeamsAnnual' : 'TeamsMonthly')
                          }
                          variant="contained"
                          style={{
                            width: '100%',
                            background: PRIMARY_COLOR,
                            marginBottom: '12px',
                            height: '50px',
                            fontSize: '18px',
                          }}
                        >
                          Buy Now
                        </Button>
                        {/* <Button
                    onClick={() =>
                      this.props.getHostedPage(this.state.billingTypeYearly ? 'TeamsAnnual' : 'TeamsMonthly')
                    }
                    variant="outlined"
                    color="primary"
                    style={{
                      width: '100%',
                      color: 'black',
                      backgroundColor: '#e3e3e3',
                      border: 0,
                      marginBottom: '12px',
                      height: '50px',
                      fontSize: '15px',
                    }}
                  >
                    GET A FREE TRIAL
                  </Button> */}
                      </CardActions>
                    </div>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ textAlign: 'left', fontSize: '18px', fontWeight: 'bold', marginLeft: '12px' }}
                    >
                      EVERYTHING IN PROFESSIONAL PLUS
                    </Typography>
                    {this.renderAdvancedAIFeatures('Teams', '', 'red')}
                  </Box>
                </CardContent>
              </Card>
            </>
          )}
        </div>
      </>
    );
  }
}

export default CustomCard;
